<svelte:head>
	
</svelte:head>

<script lang="ts">
	import { onMount } from 'svelte';
	import ProApp from "./components/ProApp.svelte";
	import { isWebGLSupported } from 'webgl-detector';
	import { isLocalHost } from './utils/Common';


	let texturePaths:string[] = [];
	let path = "/wp-content/uploads/2022/04/";
	if(isLocalHost()){
		path = "/wp-content/uploads/2022/04/";
	}
	
	texturePaths[0] = path + 'hepp-dot-pro_-_digital-art_1.jpg';
	texturePaths[1] = path + 'hepp-dot-pro_-_digital-art_2.jpg';

	let showCanvas = false;
	let showImage = false;
	onMount(() => {
		if (isWebGLSupported()){
			console.log("WebGL Active");
			showCanvas = true;
		}else{
			showImage = true;
		}
	});
</script>

<style>

	:global(body) {
		overflow-x: hidden;
		margin: 0;
		padding: 0;
		background-color: #000000;
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
</style>


{#if showCanvas}
	<ProApp {texturePaths}/>
{/if}

{#if showImage}
	<img src={texturePaths[1]}>
{/if}
